export default __webpack_public_path__ + "static/media/app_icon.0dc47e65.png";